import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import AngleForm from '../components/AngleForm';
import { Row, Col, Input, Button, Table, Select } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { ToastContainer, toast } from 'react-toastify';
import axios from '../components/Axios';
import { Link } from 'react-router-dom';

const { Option } = Select;

function MainQuora() {

  const storedUser = localStorage.getItem('user');
  const userId = storedUser ? JSON.parse(storedUser)._id : null;

  const [keyword, setKeyword]       = useState('');
  const [questionNum, setQuestionNum] = useState('');
  const [loading, setLoading]       = useState(false);
  const [questions, setQuestions]   = useState([]);
  const [angleModalVisible, setAngleModalVisible] = useState(false);
  const [dateRestrict, setDateRestrict] = useState('');

  // ── Fetch questions on mount ──────────────────────────────────────────────
  useEffect(() => {
    const fetchQuestions = async () => {
      const toastId = toast.loading('Fetching questions...');
      try {
        const timestamp = new Date().getTime();
        const response = await axios.get(`/api/questions/${userId}?_=${timestamp}`);
        setQuestions(response.data);
        toast.update(toastId, { render: 'Questions loaded successfully!', type: 'success', isLoading: false, autoClose: 3000 });
      } catch (err) {
        console.log('Error fetching questions:', err);
        toast.update(toastId, { render: 'Failed to fetch questions!', type: 'error', isLoading: false, autoClose: 3000 });
      }
    };
    fetchQuestions();
  }, []);

  // ── Submit keyword to scrape questions ────────────────────────────────────
  const handleSubmit = async () => {
    if (!keyword || !questionNum) {
      toast.error('Please fill out both fields');
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post('/api/addquestions', {
        keyword,
        questionNum: Number(questionNum),
        userId,
        dateRestrict: dateRestrict || null,
      });
      setQuestions(response.data);
    } catch (error) {
      if (error.response && error.response.data.error) {
        toast.error(error.response.data.error);
      } else {
        toast.error('An error occurred while adding questions');
      }
    } finally {
      setLoading(false);
    }
  };

  // ── Table columns ─────────────────────────────────────────────────────────
  const columns = [
    {
      title: 'Keyword',
      dataIndex: 'keyword',
      key: 'keyword',
      render: (text, record) => (
        <Link to={`/questions/${record._id}`} state={{ questionData: record }}>
          {text}
        </Link>
      ),
    },
    {
      title: 'Number of Questions',
      dataIndex: 'questionNum',
      key: 'questionNum',
    },
  ];


  // MainQuora.jsx ke useEffect mein add karo (existing useEffect ke saath ya naya)
useEffect(() => {
  const shouldShow = localStorage.getItem('showRefreshHint');
  if (shouldShow) {
    localStorage.removeItem('showRefreshHint');
    setTimeout(() => {
      toast.info('🔄 If you have just installed the extension, please refresh this page once to activate it.', {
        position: "top-right",
        autoClose: false,
        closeOnClick: true,
        closeButton: true,
        style: { fontSize: '15px', fontWeight: '500' }
      });
    }, 1500); // thoda delay taake page settle ho
  }
}, []);

  return (
    <>
      {/* <ToastContainer
        position="top-right"
        autoClose={10000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      /> */}

      <div style={{ backgroundColor: '#f9fafb' }}>
        <Header />
        <div style={{ display: 'flex' }}>
          <Sidebar />
          <main style={{ flex: 1, padding: '30px' }}>

            <div className="subMainContainer">
              <div className="headerCommom">
                <div className="heading">Quora Traffic Ops</div>
                <a className="linkNotUnderlined" href="#" target="_blank" rel="noreferrer">
                  How it works?
                  <span className="newPageIcon">
                    <span>
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M10.55 0.858814H8.21636L8.19298 0.858317C8.16961 0.856327 8.14648 0.853592 8.12335 0.848245C8.07014 0.836309 8.01916 0.813429 7.97464 0.781726C7.85852 0.69954 7.79137 0.559783 7.79921 0.417651C7.80144 0.378608 7.80928 0.33994 7.82208 0.303135C7.83763 0.258872 7.8605 0.217094 7.88972 0.180537C7.92404 0.13764 7.96631 0.101706 8.01419 0.0752234C8.05547 0.0527184 8.10023 0.0368041 8.14648 0.0289706C8.16712 0.0256135 8.17209 0.0256135 8.19298 0.0236241C9.31786 -0.00783315 10.4445 -0.00783314 11.5695 0.0233755H11.5743L11.5776 0.0236241H11.5821C11.5859 0.0241215 11.5899 0.0244945 11.5938 0.0247432L11.6055 0.0256135C11.6328 0.0298409 11.64 0.0300894 11.6668 0.0373012C11.6757 0.039788 11.6843 0.0422748 11.693 0.0451345L11.6966 0.0465022L11.7047 0.0496106L11.7119 0.0520974L11.7186 0.0548328L11.7228 0.0568222C11.7432 0.0654014 11.7624 0.0754728 11.781 0.0871602C11.8163 0.109417 11.8482 0.136771 11.8754 0.168477C11.8885 0.183771 11.9005 0.199935 11.9113 0.216968L11.9122 0.218335C11.9248 0.238105 11.9356 0.258992 11.9448 0.281003C11.9556 0.307487 11.9632 0.33422 11.9684 0.361823L11.9693 0.366051C11.9704 0.372765 11.9715 0.379106 11.9724 0.385572C11.9738 0.39614 11.9749 0.406709 11.976 0.41765C12.0075 1.53894 11.9765 2.66131 11.9765 3.78307C11.976 3.80396 11.9762 3.80931 11.974 3.82982C11.9687 3.87632 11.9554 3.92196 11.935 3.96436C11.9113 4.0136 11.8779 4.05823 11.8372 4.09441C11.808 4.12065 11.7751 4.14266 11.74 4.15932C11.6043 4.22472 11.4397 4.21079 11.3169 4.12363C11.2787 4.09665 11.245 4.06296 11.218 4.02478C11.1818 3.97381 11.1574 3.91475 11.1468 3.85295C11.1429 3.82983 11.1414 3.8067 11.1409 3.78307V1.4494L5.72693 6.86374C5.70654 6.88239 5.70181 6.88799 5.67955 6.9044C5.64586 6.92914 5.6088 6.94866 5.56927 6.96259C5.52028 6.97987 5.46793 6.9877 5.41584 6.98571C5.27906 6.98074 5.15038 6.90639 5.07777 6.79051C5.05551 6.75519 5.03872 6.71665 5.02791 6.67637C5.01709 6.63621 5.01237 6.59418 5.01398 6.55265C5.01672 6.47966 5.03872 6.4078 5.07777 6.346C5.09443 6.31927 5.11457 6.29589 5.13596 6.27277L10.5503 0.858744L10.55 0.858814Z" fill="#0048A1" />
                        <path d="M5.47049 1.13968C5.50531 1.14465 5.51451 1.14465 5.54845 1.15472C5.62504 1.17698 5.69442 1.22162 5.74652 1.28167C5.77276 1.31176 5.79439 1.34546 5.8108 1.38164C5.82746 1.41782 5.83865 1.45661 5.8445 1.49578C5.86153 1.61465 5.8256 1.73786 5.74677 1.82888C5.71195 1.86904 5.66968 1.90237 5.62256 1.92661C5.57543 1.95086 5.52371 1.96615 5.47074 1.97112C5.45769 1.97249 5.44426 1.97249 5.4312 1.97311C5.13827 1.97311 4.84521 1.97336 4.55227 1.97448C4.07905 1.97722 3.60557 1.98095 3.13296 2.00681C2.87036 2.02098 2.60737 2.04187 2.34725 2.08228C2.27676 2.0931 2.20638 2.10566 2.13638 2.1202C2.08876 2.13028 2.04138 2.14109 1.99439 2.1534C1.77655 2.2096 1.55621 2.29266 1.38525 2.44361C1.35292 2.47196 1.32283 2.50292 1.29473 2.53574C1.20956 2.63521 1.14652 2.75184 1.0984 2.87308C1.04021 3.01905 1.00117 3.17248 0.971699 3.32653C0.929673 3.544 0.90518 3.76471 0.887896 3.98491C0.858055 4.35841 0.848108 4.73306 0.842264 5.10757C0.83729 5.44316 0.836172 5.77913 0.835799 6.11494C0.83555 6.41745 0.83555 6.71984 0.835799 7.02236C0.836047 7.44736 0.837788 7.87271 0.848356 8.29768C0.857806 8.66981 0.872851 9.04295 0.915251 9.41311C0.926442 9.51059 0.939746 9.60757 0.955908 9.70418C0.985998 9.88136 1.02579 10.0584 1.08932 10.2269C1.14167 10.3659 1.21154 10.5001 1.31077 10.6119C1.50573 10.8319 1.79344 10.936 2.07247 11.0009C2.13041 11.0143 2.18884 11.0263 2.24741 11.0369C2.32151 11.0503 2.39612 11.0616 2.47072 11.0714C2.85144 11.1221 3.23662 11.1388 3.62008 11.1496C4.07268 11.1622 4.52575 11.1635 4.97873 11.1638C5.28012 11.164 5.58176 11.164 5.88341 11.1638C6.24883 11.1635 6.61401 11.1622 6.97933 11.1552C7.34525 11.1483 7.71156 11.1368 8.07637 11.1045C8.29085 11.0856 8.50557 11.0596 8.71644 11.0153C8.89474 10.9778 9.07266 10.9276 9.23591 10.8455C9.33253 10.797 9.42341 10.7363 9.50137 10.6609C9.69547 10.4731 9.7927 10.2096 9.8551 9.95224C9.86679 9.90375 9.87736 9.85476 9.88718 9.80577C9.90136 9.73391 9.91342 9.66154 9.92399 9.5888C9.93878 9.48685 9.95047 9.38439 9.96041 9.28194C9.99212 8.95418 10.0056 8.62433 10.0139 8.29482C10.0283 7.71964 10.0264 7.14396 10.0267 6.56827L10.0287 6.52873C10.0307 6.51568 10.0318 6.50225 10.0343 6.48919C10.0443 6.4371 10.0644 6.38724 10.0933 6.34247C10.1147 6.30903 10.141 6.27869 10.171 6.25283C10.2621 6.174 10.3853 6.13806 10.5041 6.1551C10.5437 6.16094 10.5821 6.17213 10.6183 6.18879C10.6665 6.2108 10.7104 6.24201 10.747 6.28043C10.8022 6.33837 10.8397 6.41161 10.8548 6.48981C10.8615 6.52463 10.8606 6.53358 10.8622 6.56889C10.862 6.86246 10.862 7.15601 10.8606 7.44958C10.859 7.73841 10.8564 8.02723 10.8492 8.3161C10.8442 8.51329 10.8372 8.71051 10.8261 8.90744C10.8177 9.0595 10.8068 9.21132 10.7921 9.36277C10.7832 9.45603 10.7726 9.54916 10.76 9.64216C10.7511 9.70818 10.7414 9.7742 10.7302 9.83985C10.6603 10.252 10.5413 10.668 10.2962 11.0121C10.2592 11.0644 10.2194 11.1146 10.177 11.1626C10.1107 11.2375 10.0378 11.3072 9.95979 11.3698C9.84478 11.4623 9.71858 11.5403 9.58604 11.6049C9.288 11.75 8.96099 11.8283 8.63485 11.8792C8.39948 11.916 8.16189 11.9385 7.9244 11.9545C7.67572 11.9715 7.42619 11.9807 7.1769 11.9868C6.81842 11.996 6.45972 11.9982 6.10125 11.9993C5.72661 12.0005 5.35238 12.0002 4.97774 11.9996C4.54717 11.9993 4.11634 11.998 3.68574 11.9873C3.28936 11.9776 2.89221 11.9614 2.49818 11.9168C2.40791 11.9065 2.31764 11.8948 2.228 11.8808C1.79431 11.8135 1.35317 11.6962 0.99059 11.4391C0.938493 11.4023 0.888134 11.3625 0.84014 11.3205C0.771632 11.26 0.708095 11.1946 0.649655 11.1244C0.608746 11.0754 0.570575 11.0238 0.53489 10.9707C0.310088 10.6354 0.199048 10.238 0.132172 9.84384C0.117376 9.75531 0.104569 9.66666 0.0935047 9.57763C0.0818169 9.48326 0.0721185 9.38826 0.0636637 9.29352C0.0497379 9.13921 0.0396664 8.98491 0.0322063 8.83035C0.0205185 8.59921 0.0138046 8.36808 0.00932825 8.1368C0.0037331 7.8379 0.00186788 7.53935 0.000997641 7.24059C-0.000370047 6.86508 -0.000121388 6.48971 0.000500291 6.1142C0.000748982 5.7126 0.00211704 5.311 0.0105721 4.90936C0.015297 4.68207 0.0225085 4.45454 0.0348179 4.22749C0.0428999 4.07543 0.0534686 3.92361 0.068017 3.77216C0.0788342 3.65627 0.0922627 3.54077 0.108674 3.42562C0.117875 3.36047 0.128195 3.29556 0.139883 3.23066C0.210008 2.84074 0.327631 2.44884 0.559025 2.1222C0.596079 2.0701 0.635615 2.01999 0.677892 1.97212C0.744163 1.8969 0.816902 1.82752 0.895109 1.7646C1.01708 1.66626 1.15187 1.58469 1.29363 1.5178C1.56518 1.39023 1.8596 1.31637 2.15454 1.26713C2.36144 1.23257 2.57009 1.20981 2.77896 1.19303C2.99145 1.17599 3.20456 1.16542 3.41792 1.15796C3.72653 1.14715 4.03537 1.14267 4.34425 1.14043C4.70657 1.13732 5.0689 1.13794 5.43097 1.1377C5.4444 1.13819 5.45745 1.13881 5.47076 1.13968L5.47049 1.13968Z" fill="#0048A1" />
                      </svg>
                    </span>
                  </span>
                </a>
              </div>

              <div className="subHeadingCommon">
                <div className="subHeading">Enter a keyword and choose how many questions you want to scrape</div>
                <div className="description">Once submitted, open the extension and press "Start Scraping" to collect questions, views, upvotes and answers.</div>
              </div>

              {/* Inputs */}
              <div style={{ marginTop: '20px' }}>
                <Row gutter={8}>
                  <Col span={6}>
                    <Input
                      style={{ width: '100%' }}
                      placeholder="Keyword"
                      value={keyword}
                      onChange={(e) => setKeyword(e.target.value)}
                      size="large"
                    />
                  </Col>
                  <Col span={4}>
                    <Input
                      style={{ width: '100%' }}
                      placeholder="Number of Questions"
                      value={questionNum}
                      onChange={(e) => setQuestionNum(e.target.value)}
                      type="number"
                      size="large"
                    />
                  </Col>
                  <Col span={6}>
                    <Select
                      style={{ width: '100%' }}
                      placeholder="Time Period (Optional)"
                      value={dateRestrict || undefined}
                      onChange={(value) => setDateRestrict(value)}
                      allowClear
                      onClear={() => setDateRestrict('')}
                      size="large"
                    >
                      <Option value="m1">Last 1 Month</Option>
                      <Option value="m6">Last 6 Months</Option>
                      <Option value="y1">Last 1 Year</Option>
                      <Option value="y2">Last 2 Years</Option>
                      <Option value="y3">Last 3 Years</Option>
                      <Option value="y4">Last 4 Years</Option>
                      <Option value="y5">Last 5 Years</Option>
                    </Select>
                  </Col>
                  <Col span={4}>
                    <Button
                      type="dashed"
                      size="large"
                      onClick={() => setAngleModalVisible(true)}
                      style={{ width: '100%' }}
                      icon={<PlusOutlined />}
                    >
                      Add Angles
                    </Button>
                  </Col>
                  <Col span={4}>
                    <Button type="primary" size="large" onClick={handleSubmit} style={{ width: '100%' }} loading={loading}>
                      Submit
                    </Button>
                  </Col>
                </Row>
              </div>

              <Row style={{ marginTop: '20px', paddingBottom: '22px' }}>
                <Col span={24}>
                  <Table
                    loading={loading}
                    columns={columns}
                    dataSource={questions}
                    rowKey="_id"
                    pagination={{ pageSize: 50 }}
                  />
                </Col>
              </Row>

            </div>
          </main>
        </div>

        {/* Angle Form Modal */}
        <AngleForm
          visible={angleModalVisible}
          onCancel={() => setAngleModalVisible(false)}
          userId={userId}
          onSuccess={() => console.log('Angle added successfully')}
        />
      </div>
    </>
  );
}

export default MainQuora;